import hoc, { IconProps } from 'bloko/blocks/icon/hoc';

const TelegramScaleMediumAppearanceDefault = hoc(
    (props: IconProps) => (
        <svg width={24} height={24} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
            <path
                d="M0.306672 11.8508C2.38415 10.6572 4.70328 9.66064 6.87011 8.65994C10.5976 7.01963 14.3403 5.41026 18.1206 3.90921C18.8567 3.65337 20.1777 3.40371 20.3077 4.54058C20.2366 6.14995 19.9452 7.749 19.7442 9.34805C19.2365 12.866 18.6486 16.3705 18.0759 19.877C17.8789 21.0449 16.4756 21.6494 15.578 20.9015C13.4214 19.3818 11.2474 17.8777 9.11817 16.323C8.41958 15.5833 9.0674 14.5218 9.68983 13.9946C11.4668 12.1686 13.3513 10.617 15.0348 8.69708C15.4897 7.55299 14.1474 8.51758 13.7047 8.81263C11.2718 10.5602 8.89885 12.4151 6.335 13.9502C5.02516 14.7033 3.49802 14.0606 2.18818 13.6407C1.01439 13.1342 -0.705665 12.6235 0.306672 11.8508Z"
                fill="var(--bloko-icon-color, var(--bloko-icon-color-default))"
            />
        </svg>
    ),
    'Telegram'
);
export default TelegramScaleMediumAppearanceDefault;
